module.exports = __webpack_public_path__ + "img/t12.9fe246db.png";